export const taiwanIdNumberLengthStrategy = (value: string) => {
  return value.length === 10;
};
